import axiosInstance from "../../apiAxios/axiosInstance";

// GET FAQ
export const getFaq = async () => {
  const response = await axiosInstance.get("/vendor/vendor-faq-get");
  return response.data;
};

export const storeFaq = async (payload) => {
  const response = await axiosInstance.post("/vendor/vendor-faq-store", payload);
  return response.data;
};
export const storeGritting = async (payload) => {
  const response = await axiosInstance.post("/vendor/vendor-greeting-store", payload);
  return response.data;
};